import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-without-registration',
    templateUrl: './without-registration.component.html',
    styleUrls: ['./without-registration.component.scss'],
    standalone: false
})
export class WithoutRegistrationComponent implements OnInit {
  @Input() icon;
  @Input() text;
  @Input() mostrarAction : boolean = false;
  @Input() textAction : string = '';

  @Output() clickk = new EventEmitter<any>();

  efect: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  clickB() {
    this.efect = true;
    this.clickk.emit({'click': true});
  }

}
